import { Container } from '@hover/blueprint';
import React, { FC, useState } from 'react';
import { StyleProps } from '@chakra-ui/react';
import Mobile from './Mobile';
import Desktop from './Desktop';
import ButtonsGroup from './ButtonsGroup';
import Tablet from './Tablet';

const wrapperStyles: StyleProps = {
  maxW: '5xl',
  overflow: 'hidden',
  mb: { base: 800, tablet: 1100, desktop: 800 },
  pb: { base: 0, desktop: 500 },
};

const TeamValuesSection: FC = () => {
  const [selectedValue, setSelectedValue] = useState<string>('think');

  const handleSelectValue = (val: string) => {
    setSelectedValue(val);
  };

  return (
    <Container {...wrapperStyles}>
      <Mobile
        selectedValue={selectedValue}
        setSelectedValue={handleSelectValue}
      />
      <Desktop
        selectedValue={selectedValue}
        setSelectedValue={handleSelectValue}
      />
      <Tablet
        selectedValue={selectedValue}
        setSelectedValue={handleSelectValue}
      />
      <ButtonsGroup />
    </Container>
  );
};

export default TeamValuesSection;
